// Whether a report gadget's queries skip the default dataset filters: its
// mode when it sets one, else off when it ignores the report's filters, else
// as the report has it
const isReportGadgetDefaultFiltersDisabled = ({
  defaultDatasetFiltersMode,
  isDefaultFiltersDisabled,
  isReportDefaultFiltersDisabled,
}: {
  defaultDatasetFiltersMode?: 'report' | 'enabled' | 'disabled';
  isDefaultFiltersDisabled?: boolean;
  isReportDefaultFiltersDisabled: boolean;
}): boolean => {
  if (defaultDatasetFiltersMode === 'enabled') {
    return false;
  }
  if (defaultDatasetFiltersMode === 'disabled') {
    return true;
  }
  return isDefaultFiltersDisabled ? true : isReportDefaultFiltersDisabled;
};

export default isReportGadgetDefaultFiltersDisabled;
